import React from "react";
import { useAppSelector } from "../../../../store/hooks";
import ListItem from "../../../roblox/Categories/_partials/_ListItem";
import ListVertical from "../../../../componets/ListVertical";

const Settings = () => {
  const categories  = useAppSelector(state => state.roblox.categories.entities);
  const ids         = useAppSelector(state => state.roblox.categories.ids);

  const renderCategory = (id: any) => {
    const category = categories[id];

    if (!category) {
      return null;
    }

    return <ListItem key={category.id} category={category} />;
  }

  return (
    <div className='v-categories-settings'>
      <h6 className="v-content-label o-sm">Settings</h6>

      <ListVertical>
        { ids && ids.map(renderCategory) }
      </ListVertical>
    </div>
  )
}

export default Settings;
